import { SET_TENANT_CONFIG, SET_TENANT_CAREERS } from '../actionTypes';

const getInitialState = () => ({
  id: '',
  primary: '',
  secondary: '',
  error: '',
  hero: '',
  heroImgPortrait: '',
  logo: '',
  name: '',
  terms_info: {},
  features: '',
  logoLink: '',
  additionalLogoLink: '',
  allTenantCareers: [],
});

export default function (state = getInitialState(), action) {
  switch (action.type) {
    case SET_TENANT_CONFIG: {
      const {
        id,
        primary,
        secondary,
        error,
        hero,
        heroImgPortrait,
        logo,
        name,
        terms_info,
        features,
        logoLink,
        dashboardHero,
        additionalLogoLink,
        buttonInfo,
        published,
      } = action.payload;

      return {
        ...state,
        id,
        primary,
        secondary,
        error,
        hero,
        heroImgPortrait,
        logo,
        name,
        terms_info,
        features,
        logoLink,
        dashboardHero,
        additionalLogoLink,
        buttonInfo,
        published,
      };
    }

    case SET_TENANT_CAREERS: {
      const { allTenantCareers } = action.payload;

      return {
        ...state,
        allTenantCareers,
      };
    }

    default:
      return state;
  }
}
